import React, { Component } from 'react'
import PropTypes from 'prop-types'
import feathers from './feathers'
import { provideState, injectState, softUpdate, hardUpdate } from 'freactal'
import styled, { ThemeProvider } from 'styled-components'
import {
  BrowserRouter as Router,
  Route,
  Link,
  withRouter,
  Redirect,
} from 'react-router-dom'
import {
  Layout,
  Header,
  Navigation,
  Drawer,
  Content,
  Snackbar,
} from 'react-mdl'
import Prompt from './components/Prompt'

import Units from './Units'
import SignIn from './SignIn'
import AssetLibrary from './AssetLibrary'

import { GREY_BLUE, GREY_LIGHT, RED, YELLOW, BLUE, TABLE_BLUE } from './colors'
import Users from './Users'

const theme = {
  main: BLUE,
  accent: GREY_BLUE,
  muted: GREY_LIGHT,
  warn: YELLOW,
  error: RED,
  tableBlue: TABLE_BLUE,
}

const StyledContent = styled(Content)`
  padding-top: 30px;
  width: 80%;
  margin: auto;
  overflow: visible;
`
const LogOut = styled.span`cursor: pointer;`

const withState = provideState({
  initialState: () => ({
    signedIn: null,
    profile: null,
    snackbarMessage: null,
    prompt: null,
  }),
  effects: {
    authenticate: async (effects, { email, password }) => {
      const { accessToken } = await feathers.authenticate({
        strategy: 'local',
        email,
        password,
      })
      await effects.processAccessToken(accessToken)
    },
    processAccessToken: async ({ updateSignin }, accessToken) => {
      const { userId } = await feathers.passport.verifyJWT(accessToken)
      const profile = await feathers.service('users').get(userId)
      await updateSignin({
        signedIn: true,
        profile,
      })
    },
    updateSignin: softUpdate((_, { signedIn, profile }) => ({
      signedIn,
      profile,
    })),
    logOut: async ({ updateSignin, snackbarAlert }) => {
      await feathers.logout()
      await updateSignin({ signedIn: false, profile: null })
      await snackbarAlert('You have been successfully logged out.')
    },
    snackbarAlert: softUpdate((_, snackbarMessage) => ({
      snackbarMessage,
    })),
    hideSnackbarAlert: hardUpdate({ snackbarMessage: null }),
    setPrompt: softUpdate((_, prompt) => ({
      prompt,
    })),
  },
})

class App extends Component {
  static childContextTypes = {
    prompt: PropTypes.func,
  }
  prompt = promptOptions =>
    new Promise(resolve => {
      this.props.effects.setPrompt({
        ...promptOptions,
        callback: selectedOption => {
          this.props.effects.setPrompt(null)
          resolve(selectedOption)
        },
      })
    })
  getChildContext() {
    return {
      prompt: this.prompt,
    }
  }
  async componentDidMount() {
    try {
      const { accessToken } = await feathers.authenticate()
      await this.props.effects.processAccessToken(accessToken)
    } catch (err) {
      this.props.effects.updateSignin({ signedIn: false, profile: null })
    }
  }
  render() {
    const {
      location: { pathname },
      effects,
      state: { signedIn, snackbarMessage, prompt, profile },
    } = this.props
    if (signedIn === null) {
      return null
    }

    if (signedIn === false && pathname !== '/signin') {
      return (
        <Redirect
          to={{
            pathname: '/signin',
            returnTo:
              !pathname || pathname.startsWith('/signin')
                ? '/units/'
                : pathname,
          }}
        />
      )
    }

    const nav = (

      profile ?
        <Navigation>
          {profile.features && profile.features.assetLibrary ? <Link to="/assetlibrary/">Asset Library</Link> : null}
          < Link to="/units/" > Units</Link>
          {profile.features && profile.features.administrator ? <Link to="/users/">Users</Link> : null}
          < Route
            path="/units/:unitId"
            // manually adding classname as Route doesn't propagate additional props
            render={({ match: { params: { unitId } } }) => (
              <Link className="mdl-navigation__link" to={`/units/${unitId}/`}>
                Current Resource
              </Link>
            )
            }
          />
          < LogOut onClick={effects.logOut} > Log Out</LogOut ></Navigation >
        : null
    )

    return (
      <Layout fixedHeader>
        <Header title="Resource Generator">{signedIn && nav}</Header>
        {signedIn && <Drawer title="Navigation">{nav}</Drawer>}
        <StyledContent>
          <Route exact path="/" render={() => <Redirect to="/units/" />} />
          <Route path="/signin" component={SignIn} />
          <Route path="/units/" component={Units} />
          {profile && profile.features && profile.features.assetLibrary ? <Route path="/assetlibrary/" component={AssetLibrary} /> : null}
          {profile && profile.features && profile.features.administrator ? <Route path="/users/" component={Users} /> : null}
          <Snackbar
            active={!!snackbarMessage}
            onTimeout={effects.hideSnackbarAlert}>
            {snackbarMessage}
          </Snackbar>
          {prompt && <Prompt {...prompt} />}
        </StyledContent>
      </Layout >
    )
  }
}

const StatefulApp = withRouter(withState(injectState(App)))

const AppWithThemeAndRouter = () => (
  <ThemeProvider theme={theme}>
    <Router>
      <StatefulApp />
    </Router>
  </ThemeProvider>
)

export default AppWithThemeAndRouter



// WEBPACK FOOTER //
// ./src/App.js